import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/AccessRightsForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps } from '../../core/utils';
import UncheckedIcon from '../../assets/images/unchecked-15x15.svg';
import CheckedIcon from '../../assets/images/checked-15x15.svg';
import classNames from 'classnames';
import autobind from 'autobind-decorator';
import {
  listRoles,
  assignUserRoles,
  listUserPermissions,
  listPermissionsManager,
} from '../../redux/actions/table/company_roles_and_permissions';
import MultiSelect from '../../components/MultiSelect';

@reduxForm({
  form: 'my_company_members.access_rights',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
}))
@subscribe(Localization, 'localization')
class AccessRightsForm extends Component {
  constructor(props) {
    super(props);

    this.state = { permissions: [], possible_roles_for_entry: [] };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  @autobind
  _togglePermission(permission) {
    const perms = this.props.values?.permissions || {};

    const newPermissions = _.has(perms, permission.id)
      ? _.omit(perms, permission.id)
      : { ...perms, [permission.id]: permission.name };

    this.props.change('permissions', newPermissions);
    this.props.touch('permissions');
    this.props.blur('permissions');
  }

  componentDidMount() {
    const userId = this.props.initialValues?.user_id;
    listRoles().then(({ response }) => {
      this.setState({
        possible_roles_for_entry: [
          ..._.map(response.data, (row) => ({
            ...row,
            value: row.id,
            label: row.name + ' (' + row.user_count + ')',
          })),
        ],
      });

      listPermissionsManager().then(({ response }) => {
        this.setState({ list_permissions_group: response.data });
      });

      listUserPermissions(userId).then(({ response }) => {
        this.setState({ permissions: response.data });
      });
    });
  }

  componentDidUpdate(prevProps) {
    const prevUserId = prevProps.initialValues?.user_id;
    const nextUserId = this.props.initialValues?.user_id;

    if (nextUserId && prevUserId !== nextUserId) {
      // učitaj permisije samo za novog korisnika
      listUserPermissions(nextUserId).then(({ response }) => {
        this.setState({ permissions: response.data });
      });
    }
  }

  render() {
    const { localization, initialValues } = this.props;

    const { permissions, possible_roles_for_entry, list_permissions_group } =
      this.state;

    const user_id = initialValues?.user_id;

    const rolesTable = [
      { id: 'view', label: 'View' },
      { id: 'create', label: 'Create' },
      { id: 'update', label: 'Update' },
      { id: 'delete', label: 'Delete' },
      // { id: 'assign', label: 'Assignee' },
      // { id: 'approve', label: 'Approve' },
      // { id: 'read', label: 'Read' },
    ];

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                name='roles'
                component={MultiSelect}
                label={__('my_company_members.flyout.role')}
                placeholder={__('my_company_members.flyout.select-role')}
                searchable
                options={possible_roles_for_entry}
                //defaultValue={ids}
                //format={(value) => {
                //  return value.map((r) => String(r.id));
                //}}
                onChange={(values) => {
                  const flyoutUserId = this.props.initialValues?.user_id;
                  if (!flyoutUserId) return;

                  const payload = {
                    role_ids: Object.values(values).filter(
                      (v) => typeof v === 'number'
                    ),
                  };

                  assignUserRoles(payload, flyoutUserId).then(() => {
                    listPermissionsManager().then(({ response }) => {
                      this.setState({ list_permissions_group: response.data });

                      listUserPermissions(flyoutUserId).then(({ response }) => {
                        this.setState({ permissions: response.data });
                      });
                    });
                  });
                  // this.props.change('role_ids', values);
                }}
              />
            </div>
            <div className={styles.f1}>{/* <InfoIcon></InfoIcon> */}</div>
          </div>
          <div className={styles.heading}>
            {/* <span className={styles.type}>
                      {__('company_and_roles_permissions.columns.type')}
                    </span>
                    <span>{__('company_and_roles_permissions.columns.view')}</span>
                    <span>{__('company_and_roles_permissions.columns.create')}</span>
                    <span>{__('company_and_roles_permissions.columns.update')}</span>
                    <span>{__('company_and_roles_permissions.columns.delete')}</span>
                    <span>{__('company_and_roles_permissions.columns.assignee')}</span> */}

            <span className={styles.type}>permission</span>

            {_.map(rolesTable, (role) => {
              return <span>{role.label}</span>;
            })}
          </div>
          <div className={styles.content}>
            {/* {_.map(listPermissions, (group, i) => { */}
            {_.map(list_permissions_group, (group, i) => {
              return (
                <div className={styles.group} key={i}>
                  <div className={styles.groupHeading}>
                    <div className={styles.name}>
                      {group.name}
                      {/* {__(
                                'company_and_roles_permissions.settings.groups.' +
                                  group.name
                              )} */}
                    </div>

                    {_.map(rolesTable, (role) => {
                      const permission = _.find(
                        group.permissions,
                        (p) => _.first(_.split(p.name, '.')) === role.id
                      );

                      return (
                        <span key={role.id}>
                          {permission ? (
                            _.get(permissions, permission.id) ? (
                              <CheckedIcon
                                className={classNames(
                                  styles.checked,
                                  styles.checkedDisabled,

                                  !user_id && styles.disabled
                                )}
                                onClick={() => {
                                  this._togglePermission(permission);
                                }}
                              />
                            ) : (
                              <UncheckedIcon
                                className={classNames(
                                  // styles.unchecked,
                                  styles.checkedDisabled,
                                  !user_id && styles.disabled
                                )}
                                onClick={() =>
                                  this._togglePermission(permission)
                                }
                              />
                            )
                          ) : (
                            <span className={styles.emptyCell} />
                          )}
                        </span>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Form>
    );
  }
}

export default AccessRightsForm;
